var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrafted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_893",
    "data-name": "Group 893",
    transform: "translate(-659.132 -4163.132)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    transform: "translate(659.132 4163.132)",
    fill: "#fff",
    stroke: "#76a94b",
    strokeWidth: 1,
    strokeDasharray: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 22.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "heart-angle-svgrepo-com",
    d: "M9.939,20.987l.523-.664ZM13.363,5.877l-.609.586.011.012Zm3.424,15.111.523.664ZM15.019,8.727a.845.845,0,0,0,1.195-1.2Zm-4.556,11.6a37.778,37.778,0,0,1-5.057-4.329A8.791,8.791,0,0,1,2.94,9.974H1.25a10.474,10.474,0,0,0,2.892,7.142,39.111,39.111,0,0,0,5.274,4.534ZM2.94,9.974a5.789,5.789,0,0,1,3.239-5.31c1.816-.83,4.256-.61,6.575,1.8l1.218-1.172c-2.752-2.859-5.945-3.33-8.5-2.164A7.477,7.477,0,0,0,1.25,9.974ZM9.416,21.651a16.616,16.616,0,0,0,1.825,1.307,4.247,4.247,0,0,0,2.122.665v-1.69a2.6,2.6,0,0,1-1.269-.434,15.1,15.1,0,0,1-1.631-1.175Zm7.893,0a39.113,39.113,0,0,0,5.274-4.534,10.474,10.474,0,0,0,2.892-7.142h-1.69a8.791,8.791,0,0,1-2.466,6.02,37.783,37.783,0,0,1-5.057,4.329ZM25.476,9.974A7.477,7.477,0,0,0,21.25,3.127c-2.55-1.166-5.744-.695-8.5,2.164l1.218,1.172c2.319-2.409,4.759-2.629,6.575-1.8a5.789,5.789,0,0,1,3.239,5.31ZM16.263,20.324A15.113,15.113,0,0,1,14.632,21.5a2.6,2.6,0,0,1-1.269.434v1.69a4.247,4.247,0,0,0,2.122-.665,16.619,16.619,0,0,0,1.825-1.307Zm-3.5-13.849,2.254,2.253,1.195-1.2L13.96,5.279Z",
    transform: "translate(669.446 4175.244)",
    fill: "#76a94b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrafted);
export default __webpack_public_path__ + "static/media/crafted.38cbc119191d891b1be08acfa7270a0a.svg";
export { ForwardRef as ReactComponent };